'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _next = require('@alifd/next');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _formatter = require('../common/formatter');

var _service = require('./service');

var _util = require('./util');

var _formFieldUtils = require('../common/formFieldUtils');

require('./view.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var DEFAULTURL = '/form/region/getNewAddressSelectRegion';
function walkTree(options, cache) {
  if (!cache) cache = {};

  if (options === null || options === undefined || !options.map) {
    return cache;
  }

  options.filter(function (item) {
    return !!item;
  }).forEach(function (item) {
    cache[item.value] = {
      label: item.text || item.label || item.value,
      value: item.value
    };
    if (!(0, _lodash.isEmpty)(item.children)) {
      walkTree(item.children, cache);
    }
  });

  return cache;
}

var MultiLevelAddressSelectField = (_temp = _class = function (_Field) {
  _inherits(MultiLevelAddressSelectField, _Field);

  function MultiLevelAddressSelectField(props) {
    _classCallCheck(this, MultiLevelAddressSelectField);

    // 用本地数据源构造地址 cache
    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    _initialiseProps.call(_this);

    var localOptions = _this.getLocalOptions();
    _this.regionCache = walkTree(localOptions) || {};
    var dataSource = props.dataSource,
        maxLevel = props.maxLevel,
        currentCode = props.currentCode;

    _this.state = _extends({}, _this.state, {
      dataSource: [],
      localOptions: localOptions,
      optionVisible: false,
      buttonDisabled: false,
      asyncUrl: (0, _lodash.isEmpty)(dataSource.url) ? DEFAULTURL : dataSource.url,
      maxLevel: maxLevel,
      currentCode: currentCode,
      maxTrueLevel: 7 // 真实level，跟节点level不是从0开始计算的
    });
    _this.onVisibleChange = _this.onVisibleChange.bind(_this);
    return _this;
  }

  MultiLevelAddressSelectField.prototype.componentDidMount = function componentDidMount() {
    _Field.prototype.componentDidMount.call(this);
    if (this.isAsyncOptions()) {
      this.onLoadData();
    }
  };

  MultiLevelAddressSelectField.prototype.isAsyncOptions = function isAsyncOptions() {
    var dataSource = this.props.dataSource;

    return dataSource.type === 'ASYNC' ? true : false;
  };

  MultiLevelAddressSelectField.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-multi-level-address'
    });
  };

  /**
   * 获取组件的选项
   */
  MultiLevelAddressSelectField.prototype.getLocalOptions = function getLocalOptions() {
    var _props$dataSource = this.props.dataSource,
        dataSource = _props$dataSource === undefined ? {} : _props$dataSource;

    return (0, _util.parseOptions)(dataSource.options);
  };

  // onChange时触发，组件的值向全局store中赋值时的转换


  MultiLevelAddressSelectField.prototype.formatOut = function formatOut(value, data, extra) {
    return (0, _formatter.formatOut)(value, 'CascadeSelect', data, extra);
  };

  MultiLevelAddressSelectField.prototype.fieldDataFormatter = function fieldDataFormatter(value) {
    var options = this.getRealOptions();
    return (0, _formatter.fieldDataFormatter)(value, 'CascadeSelect', options);
  };

  MultiLevelAddressSelectField.prototype.defaultValueFormatter = function defaultValueFormatter(value) {
    if (Array.isArray(value) && !(0, _lodash.isEmpty)(value)) {
      return value.map(function (item) {
        return item.text;
      }).join('/');
    }
    return value;
  };

  /**
   * 当前选中的节点数据 value/label/children/pos
   * 返回下一层的数据，然后自行拼装完整的数据
   */


  MultiLevelAddressSelectField.prototype.onVisibleChange = function onVisibleChange(visible, type) {
    var onChange = this.props.onChange;

    if (type === 'fromCascader') {
      return false;
    }
    this.setState({ optionVisible: visible });
  };

  MultiLevelAddressSelectField.prototype.renderControl = function renderControl() {
    var _this2 = this;

    var _props = this.props,
        _onChange = _props.onChange,
        isMustSelectLeaf = _props.isMustSelectLeaf,
        notFoundContent = _props.notFoundContent,
        _props$autoWidth = _props.autoWidth,
        autoWidth = _props$autoWidth === undefined ? false : _props$autoWidth;
    var optionVisible = this.state.optionVisible;

    var controlProps = this.getControlProps();
    var listStyle = (0, _formFieldUtils.isIE)() ? { width: '150px' } : { minWidth: '150px', width: 'auto' };
    if (autoWidth) {
      var cascadeSize = 3; // this.getCascadeSize();
      listStyle = { width: 1 / cascadeSize * 100 + '%' };
    }
    // console.log(this.getFieldValue())
    var fieldProps = _extends({}, controlProps, {
      notFoundContent: notFoundContent,
      autoWidth: autoWidth,
      listStyle: listStyle,
      dataSource: this.getRealOptions(),
      valueRender: function valueRender(item) {
        var fieldValue = _this2.getFieldValue();
        if (!(0, _lodash.isEmpty)(fieldValue)) {
          return fieldValue.map(function (item) {
            if (item && (item.text || item.label) && item.text !== item.value) {
              return item.text || item.label;
            } else if (item && item.value) {
              return _this2.regionCache[item.value] && _this2.regionCache[item.value]['label'] || item.value;
            } else {
              return item || '';
            }
          }).join('/');
        }
        return '';
      },
      canOnlyCheckLeaf: isMustSelectLeaf,
      style: _extends({}, controlProps.style, { width: '100%' }),
      onChange: function onChange(value, data, extra) {
        _onChange({ value: _this2.formatOut(value, data, extra) });
      }
    });
    if (this.isAsyncOptions()) {
      fieldProps.loadData = this.onLoadData;
    }
    return _react2.default.createElement(_next.CascaderSelect, _extends({
      changeOnSelect: true,
      onVisibleChange: this.onVisibleChange,
      visible: optionVisible
    }, fieldProps));
  };

  return MultiLevelAddressSelectField;
}(_vuFusionField2.default), _class.displayName = 'MultiLevelAddressSelect', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  notFoundContent: '无选项',
  autoWidth: false
}), _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getRealOptions = function () {
    return _this3.isAsyncOptions() ? _this3.state.dataSource : _this3.state.localOptions;
  };

  this.onLoadData = function (selected) {
    var _state = _this3.state,
        prevDataSource = _state.dataSource,
        asyncUrl = _state.asyncUrl,
        maxLevel = _state.maxLevel,
        maxTrueLevel = _state.maxTrueLevel,
        currentCode = _state.currentCode;

    var dataSource = (0, _lodash.cloneDeep)(prevDataSource);
    var code = selected ? selected.value : currentCode;
    var params = {
      parentCode: selected ? code : null,
      currentCode: selected ? null : code,
      asyncUrl: asyncUrl //默认的路径
    };
    return (0, _service.queryRegion)(params).then(function (data) {
      if ((0, _lodash.isEmpty)(data)) {
        return false;
      }
      var options = (0, _util.convertDataSource)(data, maxTrueLevel);
      if (!selected) {
        dataSource = options;
        _this3.setState({ maxTrueLevel: data[0] && data[0].level ? maxLevel - 1 + data[0].level : 7 });
      } else {
        var pos = selected.pos.split('-');
        pos.shift();
        var current = pos.reduce(function (source, current, index) {
          return index === pos.length - 1 ? source[current] : source[current].children;
        }, dataSource);
        current.children = options;
      }
      _this3.setState({ dataSource: dataSource });
    });
  };
}, _temp);
exports.default = MultiLevelAddressSelectField;
module.exports = exports['default'];